/** @module polyfills */

/**
 * Ensures support for modern <picture/> element.
 */
export function picturefill() {
    if (!window.HTMLPictureElement === true) {
        import(/* webpackMode: "lazy" */ 'picturefill');
    }
}
